import { ProductType } from '../../constants';

export type ProductDetailData = {
  product: ProductDetail;
  categories: Category[];
  reviewStatic: ReviewStatic;
  shippingPolicy: ShippingPolicy;
  relatedCollections: RelatedCollections;
  rank: Rank[];
  awardsAndHonor: AwardsAndHonor;
};

export type ProductDetailBase = {
  productId: string;
  sku: string;
  name: string;
  brand: string;
  productLink: string;
  productImageUrls: string[];
  category: string[];
  modifiedAt: string;
  size: string;
  pack: string;
  currency: string;
  type: string;
  status: string;
  description?: string;
  additionalPrices: AdditionalPrice[];
  learnMoreUrl?: string[];
};

export type ProductDetailInfo = ProductDetailBase & {
  originalPrice: number;
  salePrice?: number;
};

export type SimpleProductDetail = ProductDetailInfo & {
  type: ProductType.Simple;
};

export type VariationProductDetail = ProductDetailInfo & {
  type: ProductType.Variation;
};

export type VariableProductDetail = ProductDetailBase & {
  type: ProductType.Variable;
  variations: VariationProductDetail[];
};

export type ProductDetail = SimpleProductDetail | VariableProductDetail;

export interface AdditionalPrice {
  currency: string;
  originalPrice: number;
  salesPrice: number;
}

export interface Category {
  termId: number;
  name: string;
  slug: string;
  taxonomy: string;
  description: string;
  count: number;
  parentTermId: number;
  categoryHierarchy: CategoryHierarchy[];
  rankInTerm: number;
}

export interface CategoryHierarchy {
  termId: number;
  name: string;
  slug: string;
  taxonomy: string;
  categoryHierarchy: CategoryHierarchy[];
}

export interface ReviewStatic {
  productId: string;
  averageRate: number;
  totalReviews: number;
}

export interface ShippingPolicy {
  currency: string;
  minDeliveryDays: number;
  maxDeliveryDays: number;
  shippingFee: number;
  freeShippingThreshold: number;
}

export interface RelatedCollections {
  brand: Brand;
  category: Category;
}

export interface Brand {
  count: number;
  termId: number;
  name: string;
  slug: string;
  description: string;
  brandImageUrl: string;
}

export interface Rank {
  termId: number;
  name: string;
  slug: string;
  description?: string;
  count?: number;
  brandImageUrl?: string;
  rankInTerm: number;
  taxonomy: string;
}

export interface AwardsAndHonor {
  awards: Award[];
  honors: any[];
}

export interface Award {
  termId: number;
  name: string;
  slug: string;
  description?: string;
  count?: number;
  brandImageUrl?: string;
  rankInTerm: number;
}
